module.exports = __webpack_public_path__ + "img/Recubre_Repello Gris.e6a1ca88.png";